document.addEventListener('DOMContentLoaded', function() {
  const timerEl = document.getElementById('countdown-timer');
  const defaultEl = document.getElementById('default-message');
  if (!timerEl || !defaultEl) return;

  const titleEl   = timerEl.querySelector('.timer-title');
  const hoursSpan   = document.getElementById('hours');
  const minutesSpan = document.getElementById('minutes');
  const secondsSpan = document.getElementById('seconds');

  // London "now" (DST-safe, no string parsing)
  function londonNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    const get = t => parseInt(parts.find(p => p.type === t).value, 10);
    // Create a Date using London's wall clock values
    return new Date(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
  }

  // Map to display label based on day of week (Mon=1..Sun=0)
  function nextDeliveryLabel(nowLocal) {
    const dow = nowLocal.getDay(); // 0=Sun,1=Mon,...,6=Sat
    if (dow >= 1 && dow <= 4) return 'tomorrow'; // Mon–Thu
    if (dow === 5 || dow === 6) return 'Monday'; // Fri or Sat
    return 'Tuesday';                             // Sunday
  }

  function updateDisplay() {
    const now = londonNow();

    // Cutoff = 2 PM (14:00) London time today
    const cutoff = new Date(now);
    cutoff.setHours(14, 0, 0, 0);

    const diffMs = cutoff - now;

    if (diffMs > 0) {
      // Before 2pm → show timer + tailored headline
      if (titleEl) {
        titleEl.textContent = `Order now for delivery from ${nextDeliveryLabel(now)}!`;
      }

      const hrs  = Math.floor(diffMs / 3600000);
      const mins = Math.floor((diffMs % 3600000) / 60000);
      const secs = Math.floor((diffMs % 60000) / 1000);

      hoursSpan.textContent   = String(hrs).padStart(2, '0');
      minutesSpan.textContent = String(mins).padStart(2, '0');
      secondsSpan.textContent = String(secs).padStart(2, '0');

      timerEl.style.display = 'block';
      defaultEl.style.display = 'none';
    } else {
      // After 2pm → hide timer, show default message
      timerEl.style.display = 'none';
      defaultEl.style.display = 'block';
    }
  }

  updateDisplay();
  setInterval(updateDisplay, 1000);
});
